import React, { useState, useEffect, useRef } from 'react';
import LoadingUI from '../../components/ui/LoadingUI';
import { useStyles } from './Style'
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';
import { VehicleType, VehicleTypePost, VehicleTypePut } from '../../interfaces/VehicleType';
import VehicleTypeApi from '../../services/VehicleTypeApi';
import { useAuth } from '../../hooks/auth';
import { useForm } from 'react-hook-form';
import TextField from '../../components/Form/TextField';
import * as Yup from 'yup';

type Props = {
    vehicleTypeCode: string,
    clickHandlerCalbkack?: () => void,
    clickHandlerClose?: () => void,
    handleSetSuccess?: (value: boolean) => void,
}

interface IFormInput {
    code: any;
    description: any;
}

const VehicleTypeForm: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [vehicleType, setVehicleType] = useState<VehicleType | any>();
    const { t } = useTranslation("VehicleType");
    const [loading, setLoading] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t: tval } = useTranslation("Validation");
    const { enqueueSnackbar } = useSnackbar();
    useAuth();
    const { control, handleSubmit, clearErrors, setError, setValue } = useForm<IFormInput>(
        {
            defaultValues: { code: '', description: '' }
        }
    )

    const refCode = useRef<HTMLElement>(null)
    const refDescription = useRef<HTMLElement>(null)

    const getVehicleType = () => {
        if (props.vehicleTypeCode && props.vehicleTypeCode !== '') {
            setLoading(true);
            VehicleTypeApi.getVehicleType(props.vehicleTypeCode).then((result) => {
                if (result) {
                    setVehicleType(result)
                    setValue("code", result.code)
                    setValue("description", result.description)
                }
            }).finally(() => {
                setLoading(false);
            });
        }
        else {
            setVehicleType(null)
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        getVehicleType()
    }, [props])

    
    useEffect(() => {
        if (props.vehicleTypeCode !== '')
            refDescription.current?.focus()
        else
            refCode.current?.focus()
        
    }, [props.vehicleTypeCode])

    

    const yupValidation = async (data: any) => {

        var result = false
        clearErrors(["code", "description"])

        try {
            const schema = Yup.object().shape({
                code: Yup.string().required(tval("requiredField")),
                description: Yup.string().required(tval("requiredField")),
            })

            await schema.validate(data, {
                abortEarly: false,
            })

            result = true
        } catch (err) {
            
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    setError(error.path?.split('.')[0] as "code" | "description", { message: error.message })
                })
            }

            result =  false
        }

        return result
    }

    const saveData = async (data: any) => {
        var validForm = await yupValidation(data)

        if (validForm === false)
            return

        setOpenBackdrop(true);        
        if (props.vehicleTypeCode && props.vehicleTypeCode !== '') {
            let put:VehicleTypePut = {
                code: vehicleType.code,
                description: data.description
            }

            handleSubmitPut(put)
        }
        else{
            let post:VehicleTypePost = {
                code: data.code,
                description: data.description,
            }

            handleSubmitPost(post)
        }
    }

    const handleSubmitPost = (data: VehicleTypePost) => {
        VehicleTypeApi.postVehicleType(data)
            .then(result => {
                enqueueSnackbar(t("returnSubmitFormSuccess"), { variant: 'success' });
                if (props && props.handleSetSuccess)
                    props.handleSetSuccess(true);
                if (props && props.clickHandlerCalbkack)
                    props.clickHandlerCalbkack()
            }).finally(() => {
                setOpenBackdrop(false);
            });
    }

    const handleSubmitPut = (data: VehicleTypePut) => {
        VehicleTypeApi.putVehicleType(data)
                .then(result => {
                    enqueueSnackbar(t("returnSubmitEditFormSuccess"), { variant: 'success' });
                    if (props && props.handleSetSuccess)
                        props.handleSetSuccess(true);
                    if (props && props.clickHandlerCalbkack)
                        props.clickHandlerCalbkack()
                }).finally(() => {
                    setOpenBackdrop(false);
                });
    }

    return (
        
        loading ?
        <LoadingUI />
        :
        <React.Fragment>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <form onSubmit={handleSubmit(saveData)} >     
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <TextField 
                                label={t("code")} 
                                name="code" 
                                control={control} 
                                fullWidth
                                inputRef={refCode}
                                inputProps={{ maxLength: 2 }}
                                style={{ margin: '0px' }}
                                disabled={props.vehicleTypeCode && props.vehicleTypeCode !== '' ? true : false} /> 
                        </Grid>
                        <Grid item xs={12}>
                            <TextField 
                                label={t("description")} 
                                name="description" 
                                control={control} 
                                inputRef={refDescription}
                                fullWidth
                                style={{ margin: '0px' }}
                                inputProps={{ maxLength: 50 }} /> 
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: 30 }} spacing={2}>
                        <Grid item  xs={12} className={classes.footForm}>
                            <Button variant="contained" className={classes.rootCancelButton} onClick={() => props && props.clickHandlerClose ? props.clickHandlerClose() : null}>
                                {t("cancel")}
                            </Button>
                            <Button type="submit" variant="contained" color="primary" className={classes.rootButton}>
                                {t("confirm")}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
    )
}
export default VehicleTypeForm;
